import ERROR_CODES from './serverErrorCodes'

const responseWithErrorCode = (response) => Boolean(response?.body?.code)

const getErrorCodesFromResponse = (response) => {
  const errorResponseCode = response.body
  return errorResponseCode.code.split('.')
}

const findErrorCode = (code, errorCodes) => {
  const matchedErrorCode = errorCodes.find((errorCode) => {
    return errorCode.code === code
  })
  return matchedErrorCode || null
}

const findErrorMessage = (httpErrorCode, customErrorCode = null) => {
  let errorCode = findErrorCode(httpErrorCode, ERROR_CODES)
  if (customErrorCode !== null && errorCode?.customCodes) {
    errorCode = findErrorCode(customErrorCode, errorCode.customCodes)
  }
  return errorCode ? errorCode.message : ''
}

export function getErrorMessageFromResponse (response) {
  const body = response.body ?? response.data
  if (response.status > 499 || body == null) { throw response }
  if (responseWithErrorCode(response)) {
    const [httpErrorCode, customErrorCode] = getErrorCodesFromResponse(response)
    return findErrorMessage(httpErrorCode, customErrorCode)
  }
  if (typeof body === 'object' && !Array.isArray(body)) {
    const firstError = Object.values(body).at(0)
    if (firstError != null) {
      return Array.isArray(firstError) ? firstError.at(0) : firstError
    }
  }
  return body
}
